const popoverStyles = {
  paper: {
    width: '400px',
    maxHeight: '934px',
  },
}

export default popoverStyles
